"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
function findLowestPrice(inventory) {
    if (lodash_1.isEmpty(inventory.usedLowPrice)) {
        return inventory.newLowPrice;
    }
    if (lodash_1.isEmpty(inventory.newLowPrice)) {
        return inventory.usedLowPrice;
    }
    if (inventory.newLowPrice.amount < inventory.usedLowPrice.amount) {
        return inventory.newLowPrice;
    }
    return inventory.usedLowPrice;
}
function renderMeta(count, price) {
    if (!price) {
        return null;
    }
    return (React.createElement("span", { className: "d-none" },
        React.createElement("meta", { itemProp: "offerCount", content: String(count) }),
        React.createElement("meta", { itemProp: "priceCurrency", content: price.currency }),
        React.createElement("meta", { itemProp: "lowPrice", content: price.amount })));
}
function BrandMetaData(props) {
    if (!props.brandName) {
        return null;
    }
    return (React.createElement("meta", { content: props.brandName, itemType: "http://schema.org/Brand", itemProp: "brand" }));
}
exports.BrandMetaData = BrandMetaData;
function PriceMetaData(props) {
    var inventory = props.inventory, newOnly = props.newOnly, usedOnly = props.usedOnly;
    if (!inventory) {
        return null;
    }
    if (newOnly) {
        return renderMeta(inventory.newTotal, inventory.newLowPrice);
    }
    if (usedOnly) {
        return renderMeta(inventory.usedTotal, inventory.usedLowPrice);
    }
    var total = inventory.usedTotal + inventory.newTotal;
    var lowestPrice = findLowestPrice(inventory);
    return renderMeta(total, lowestPrice);
}
exports.PriceMetaData = PriceMetaData;
function NameMetaData(props) {
    if (!props.title) {
        return null;
    }
    return React.createElement("meta", { content: props.title, itemProp: "name" });
}
exports.NameMetaData = NameMetaData;
//# sourceMappingURL=metadata_helper.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/metadata_helper.js
// module id = wtkt
// module chunks = 20 21